import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '..';
import { AssetsListingState } from './AssetsListingState';

export type AssetsListing = {
  assetListingState: AssetsListingState;
};

export const initialState: AssetsListing = {
  assetListingState: new AssetsListingState(),
};

const assetListingSlice = createSlice({
  name: 'assetListing',
  initialState,
  reducers: {
    updateAssetSideBar: (state, action) => {
      state.assetListingState.isSidebarShowing = action.payload;
      // console.log('state.assetListingState', state.assetListingState);
    },
    updateSearchForm: (state, action) => {
      state.assetListingState.searchForm = action.payload;
    },
    updatePagination: (state, action) => {
      // console.log(action.payload);
      state.assetListingState.pagination = action.payload;
      // console.log(state.assetListingState.pagination);
    },
    updateLastSortSettings: (state, action) => {
      state.assetListingState.lastSortSettings = action.payload;
    },
    reset: (state) => {
      state.assetListingState.reset();
    },
    updateEditMultipleForm: (state, action) => {
      state.assetListingState.editMultipleForm = action.payload;
    },
    updateCureentCommonModel: (state, action) => {
      state.assetListingState.editMultipleForm.currentCommonModel = action.payload;
    },
    isEditMultipleFormSaving: (state, action) => {
      state.assetListingState.editMultipleForm.isSaving = action.payload;
    },
    updatePlayListduration: (state, action) => {
      state.assetListingState.playListDuration = action.payload;
    },
    updateLegendConfig: (state, action) => {
      state.assetListingState.legendConfigs = action.payload;
    },
  },
});

export const {
  updateAssetSideBar,
  updateSearchForm,
  updatePagination,
  updateLastSortSettings,
  reset,
  updateEditMultipleForm,
  isEditMultipleFormSaving,
  updateCureentCommonModel,
  updatePlayListduration,
  updateLegendConfig,
} = assetListingSlice.actions;

// export assetListingSelector selector to get the slice in any component
export const assetListingSelector = (state: RootState) => state.assetListing;
// export The reducer
const assetListingReducer = assetListingSlice.reducer;
export default assetListingReducer;
